import { dataReportSettingsSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportSettingsSolid = /*#__PURE__*/createIcon(dataReportSettingsSolid)
export default IconReportSettingsSolid
